import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import GetInvolved from "@/components/sections/GetInvolved";
import Gallery from "@/components/sections/Gallery";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <About />
      <Services />
      <GetInvolved />
      <Gallery />
      <Contact />
      <Footer />
    </main>
  );
}
